import React, { useState } from "react";
import { DropdownToggle, DropdownMenu, Dropdown } from "reactstrap";
import { Icon } from "../../../../components/Component";
import { LinkList, LinkItem } from "../../../../components/links/Links";
import UserAvatar from "../../../../components/user/UserAvatar";
import { useTheme, useThemeUpdate } from "../../../provider/Theme";
import { decrypt } from "../../../../utils/Encrypt";
import { adminLogoutAPI } from "../../../../api/auth";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";

const User = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const themeUpdate = useThemeUpdate();
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((prevState) => !prevState);
  const enc = JSON.parse(localStorage.getItem("userDetail"));
  const user = decrypt(enc?.data || []);

  const handleLogout = () => {
     const type = localStorage?.getItem("type");     
      const url = type == "admin" ? "login" : type == "lms_admin" ? "lms-logout" : "";
    adminLogoutAPI({},url)
      .then((res) => {
        const status = decrypt(res.data.status);
        if (status === "success"||status) {
          localStorage.clear();
          navigate("/auth-login");
          toast.success(res.data.message);
        } else if (status === "failed"|!status) {
          toast.error(res.data.message);
        } else if (status === "expired") {
          localStorage.clear();
          navigate("/auth-login");
          toast.success(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  return (
    <Dropdown isOpen={open} className="user-dropdown" toggle={toggle}>
      <DropdownToggle
        tag="a"
        href="#toggle"
        className="dropdown-toggle"
        onClick={(ev) => {
          ev.preventDefault();
        }}
      >
        <div className="user-toggle">
          <UserAvatar icon="user-alt" className="sm" />
          <div className="user-info d-none d-md-block">
            <div className="user-status text-capitalize">{user?.role}</div>
            <div className="user-name dropdown-indicator text-capitalize">
              {user?.first_name + " " + user?.last_name}
            </div>
          </div>
        </div>
      </DropdownToggle>
      <DropdownMenu end className="dropdown-menu-md dropdown-menu-s1">
        <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
          <div className="user-card sm">
            <UserAvatar icon="user-alt" className="sm" />
            {/* <div className="user-avatar">
             <span>{user?.name?.length>0?findUpper(user?.first_name +" " +user?.last_name):null}</span>
            </div> */}
            <div className="user-info">
              <span className="lead-text text-capitalize">{user?.first_name + " " + user?.last_name}</span>
              <span className="sub-text">{user?.email}</span>
            </div>
          </div>
        </div>
        {/* <div className="dropdown-inner"> */}
          {/* <LinkList> */}
            {/* <LinkItem link="/user-profile-regular" icon="user-alt" onClick={toggle}>
              View Profile
            </LinkItem>
            <LinkItem link="/user-profile-setting" icon="setting-alt" onClick={toggle}>
              Account Setting
            </LinkItem>
            <LinkItem link="/user-profile-activity" icon="activity-alt" onClick={toggle}>
              Login Activity
            </LinkItem> */}
            {/* <li>
              <a
                className={`dark-switch ${theme.skin === "dark" ? "active" : ""}`}
                href="#"
                onClick={(ev) => {
                  ev.preventDefault();
                  themeUpdate.skin(theme.skin === "dark" ? "light" : "dark");
                }}
              >
                {theme.skin === "dark" ? (
                  <>
                    <em className="icon ni ni-sun"></em>
                    <span>Light Mode</span>
                  </>
                ) : (
                  <>
                    <em className="icon ni ni-moon"></em>
                    <span>Dark Mode</span>
                  </>
                )}
              </a>
            </li> */}
          {/* </LinkList> */}
        {/* </div> */}
        <div className="dropdown-inner">
          <LinkList>
            <a style={{ cursor: "pointer" }} onClick={handleLogout}>
              <Icon name="signout"></Icon>
              <span>Sign Out</span>
            </a>
          </LinkList>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default User;
